import script from "./AppLayoutHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLayoutHeader.vue?vue&type=script&lang=ts&setup=true"

import "./AppLayoutHeader.vue?vue&type=style&index=0&id=a10bd576&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a10bd576"]])

export default __exports__